import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const publicApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Service pour les blogs publics
const publicBlogService = {
  getPublicBlogs: async (limit = 10) => {
    try {
      const response = await publicApi.get('/blogs/public', {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des blogs:', error);
      throw error;
    }
  },

  getBlogBySlug: async (slug) => {
    try {
      const response = await publicApi.get(`/blogs/public/${slug}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du blog:', error);
      throw error;
    }
  }
};

// Service pour les produits publics
const publicProductService = {
  getProducts: async (params = {}) => {
    try {
      const response = await publicApi.get('/products/public', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits:', error);
      throw error;
    }
  },

  getProductBySlug: async (slug) => {
    try {
    const response = await publicApi.get(`/products/slug/${slug}`);
    return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du produit:', error);
      throw error;
    }
  },

  getFacets: async () => {
    try {
      const response = await publicApi.get('/products/facets');
    return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des facettes:', error);
      throw error;
    }
  }
};

// Service pour les catégories publiques
const publicCategoryService = {
  getCategories: async () => {
    try {
    const response = await publicApi.get('/categories/slug/all');
    return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des catégories:', error);
      throw error;
    }
  },

  getCategoryBySlug: async (slug) => {
    try {
    const response = await publicApi.get(`/categories/slug/${slug}`);
    return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la catégorie:', error);
      throw error;
    }
  }
};

// Service pour les devis publics
const publicQuoteService = {
  createQuote: async (quoteData) => {
    try {
    const response = await publicApi.post('/quotes', quoteData);
    return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du devis:', error);
      throw error;
    }
  }
};

// Service pour les publicités (endpoints publics)
const advertisementService = {
  // Obtenir les publicités actives
  getActiveAdvertisements: async () => {
    try {
      const response = await publicApi.get('/advertisements/active');
    return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des publicités:', error);
      throw error;
    }
  }
};

export { 
  publicBlogService, 
  publicProductService, 
  publicCategoryService, 
  publicQuoteService,
  advertisementService 
};
export default publicApi;